import styled from 'styled-components';

export const StyledLogoHeader = styled.div`
  font-family: InspireTWDC;
  color: ${({ theme }): string => theme.colors!.colorWhite};
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 30px;
  display: flex;
`;
